import React, { useState, useEffect } from 'react';

const F = ({ label, children }) => (
  <div style={{ marginBottom: 10 }}>
    <label style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: '#888', display: 'block', marginBottom: 3 }}>{label}</label>
    {children}
  </div>
);
const TA = (props) => <textarea {...props} style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #ccc', borderRadius: 8, fontSize: 12, fontFamily: 'inherit', color: '#111', background: '#fff', resize: 'vertical', boxSizing: 'border-box', ...(props.style||{}) }} />;

export default function ReportDialog({ open, onClose, mode, prefill, api, filename }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && prefill) setS(JSON.parse(JSON.stringify(prefill.sections))); }, [open, prefill]);
  if (!open || !s) return null;
  const set = (k) => (e) => setS(prev => ({ ...prev, [k]: e.target.value }));
  const setCoding = (i, k, v) => setS(prev => { const c = [...(prev.sample_coding||[])]; c[i] = { ...c[i], [k]: v }; return { ...prev, sample_coding: c }; });

  const generate = async () => {
    setBusy(true);
    try {
      const r = await api.post('/taste/report-v2', { sections: s, meta: prefill.meta, results: prefill.results, mode }, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a'); a.href = url; a.download = filename || 'report.pdf'; a.click();
      URL.revokeObjectURL(url);
      onClose();
    } catch (e) {
      let msg = 'Generation failed';
      try { msg = JSON.parse(await e.response.data.text()).error || msg; } catch {}
      alert(msg);
    }
    setBusy(false);
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,8,18,0.55)', zIndex: 1300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 640, maxWidth: '96%', maxHeight: '92vh', overflowY: 'auto', background: '#fff', borderRadius: 14, padding: 20, boxShadow: '0 16px 48px rgba(0,0,0,0.35)' }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#7B2D6B', marginBottom: 2 }}>{mode === 'compare' ? 'Product Comparison Report' : 'Sensory Evaluation Report'}</div>
        <div style={{ fontSize: 11, color: '#888', marginBottom: 12 }}>Review and edit each section, then Generate. All fields are editable.</div>

        <F label="1. Aim"><TA rows={2} value={s.aim} onChange={set('aim')} /></F>
        <F label="2. Reason for Evaluation"><TA rows={2} value={s.reason} onChange={set('reason')} /></F>
        <F label="3. Product Details"><TA rows={3} value={s.product_details} onChange={set('product_details')} /></F>

        <F label="4. Sample Identification / Coding">
          {(s.sample_coding||[]).map((row, i) => (
            <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
              <input value={row.code} onChange={e => setCoding(i, 'code', e.target.value)} style={{ width: 110, padding: '5px 8px', border: '1px solid #ccc', borderRadius: 6, fontSize: 12, color: '#111', background: '#fff' }} />
              <input value={row.description} onChange={e => setCoding(i, 'description', e.target.value)} placeholder="Description" style={{ flex: 1, padding: '5px 8px', border: '1px solid #ccc', borderRadius: 6, fontSize: 12, color: '#111', background: '#fff' }} />
              <input value={row.status} onChange={e => setCoding(i, 'status', e.target.value)} placeholder="Status" style={{ width: 130, padding: '5px 8px', border: '1px solid #ccc', borderRadius: 6, fontSize: 12, color: '#111', background: '#fff' }} />
            </div>
          ))}
        </F>

        <F label="5. Evaluation Procedure"><TA rows={3} value={s.procedure} onChange={set('procedure')} /></F>
        <F label="6. Sensory Evaluation"><TA rows={2} value={s.sensory_eval} onChange={set('sensory_eval')} /></F>
        <div style={{ fontSize: 11, color: '#7B2D6B', background: '#f9f3f8', border: '1px dashed #7B2D6B', borderRadius: 8, padding: '6px 10px', marginBottom: 10 }}>
          7. Results — generated from panel data: {prefill.meta.participants} participants, {prefill.results.samples.length} sample(s), {prefill.results.params.length} parameters{mode === 'compare' ? ' (overall likability chart only)' : ' (full table + chart)'}.
        </div>
        <F label="8. Interpretation (auto-generated — edit as needed)"><TA rows={4} value={s.interpretation} onChange={set('interpretation')} /></F>
        <F label="9. Conclusion and Ranking (auto-generated — edit as needed)"><TA rows={3} value={s.conclusion_ranking} onChange={set('conclusion_ranking')} /></F>
        <F label="10. Final Conclusion (auto-generated — edit as needed)"><TA rows={3} value={s.final_conclusion} onChange={set('final_conclusion')} /></F>
        <F label="Approved by"><input value={s.approved_by} onChange={set('approved_by')} style={{ width: 240, padding: '6px 10px', border: '1px solid #ccc', borderRadius: 8, fontSize: 12, color: '#111', background: '#fff' }} /></F>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary btn-sm" disabled={busy} onClick={generate}>{busy ? 'Generating…' : '⬇ Generate PDF'}</button>
        </div>
      </div>
    </div>
  );
}
